import _ from 'lodash';

export const campaignsSelector = state => _.get(state, 'home.campaigns', []);
